module.exports = __webpack_public_path__ + "img/homeProduct.0c7bc82f.png";